"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reloadShoppingContext = reloadShoppingContext;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
function reloadShoppingContext() {
    const reloadContext = (0, _checkoutUtils.getShoppingContextReloader)(_constants.APP_NAME);
    reloadContext();
}
